// English translations
const enTranslations = {
  // Navigation
  counterPicker: 'Counter Picker',
  winRate: 'Win Rate',
  tierList: 'Tier List',
  // App.js
  appTitle: 'Marvel Rivals Counter Picker',
  loading: 'Loading Marvel Rivals data...',
  gameSettings: 'Game Settings',
  enemyTeam: 'Enemy Team',
  alliedTeam: 'Allied Team',
  clear: 'Clear',
  selectEnemyHeroesPrompt: 'Select enemy heroes to see counter recommendations',
  dataUpdated: 'Data updated for Marvel Rivals version 20250530',
  counterCalculation: 'Best heroes score is calculated based on counters, meta, maps, rank and synergies that counter enemies',
  copyright: '© 2025 Marvelrivals.vip - All rights reserved',
  
  // Disclaimer
  disclaimerTitle: 'Early Development Notice',
  disclaimerText: 'This application is currently in its early development phase. Due to limited access to comprehensive match data, we rely on external resources for key insights: counter strategies are sourced from peakrivals.com and subjective community-driven sources (including platforms like Reddit), hero statistics and data from mrapi.org. Please note that the information provided here is not definitive and should not be treated as a guaranteed path to victory. Success ultimately hinges on in-game communication, strategic decision-making, and your personal skill mastery with a chosen character. Always adapt and refine your approach based on real-time match dynamics.',
  disclaimerButton: 'I Understand',
  showDisclaimer: 'Show Disclaimer',
  
  // HeroSelection.js
  selectEnemyTeam: 'Select Enemy Team',
  selectAlliedTeam: 'Select Allied Team',
  tank: 'Tank',
  damage: 'Damage',
  support: 'Support',
  vanguard: 'Vanguard',
  duelist: 'Duelist',
  strategist: 'Strategist',
  
  // BannedHeroes.js
  bannedHeroes: 'Banned Heroes',
  noBannedHeroesYet: 'No heroes banned yet. Select heroes below to ban them.',
  availableHeroes: 'Available Heroes',
  
  // MapRankSelection.js
  map: 'Map',
  anyMap: 'Any Map',
  rank: 'Rank',
  anyRank: 'Any Rank',
  
  // CounterDisplay.js
  recommendedCounterPicks: 'Recommended Counter Picks',
  alternativePicks: 'Alternative Picks',
  countersEnemies: 'Counters',
  counteredBy: 'Countered by',
  metaRank: 'Tier',
  mapBonus: 'Map Bonus',
  synergiesWith: 'Synergies with',
  yes: 'Yes',
  no: 'No',
  alliedTeamRatings: 'Allied Team Ratings',
  and: 'and',
  
  // Tabs
  heroSelection: 'Hero Selection',
  bannedHeroesTab: 'Banned Heroes',
  
  // Language
  language: 'Language',
  english: 'English',
  spanish: 'Spanish',
  
  // Win Rate Page
  heroWinRates: 'Hero Win Rates',
  filterByRole: 'Filter by Role',
  allRoles: 'All Roles',
  hero: 'Hero',
  role: 'Role',
  pickRate: 'Pick Rate',
  banRate: 'Ban Rate',
  gameMode: 'Game Mode',
  quickPlay: 'Quick Play',
  competitive: 'Competitive',
  competitiveRank: 'Competitive Rank',
  competitiveSummary: 'All Ranks',
  bronze: 'Bronze',
  silver: 'Silver',
  gold: 'Gold',
  platinum: 'Platinum',
  diamond: 'Diamond',
  grandmaster: 'Grandmaster',
  celestial: 'Celestial And Above',
  
  // Tier List Page
  heroTierRankings: 'Hero Tier Rankings',
  tierListDescription: 'Heroes are ranked based on their current performance in the meta.',
  tier: 'Tier',
  new: 'New',
  noHeroesInTier: 'No heroes in this tier'
};

export default enTranslations;